import moodyImage from '../images/project/moody.png';
import hearNatureImage from '../images/project/hear-nature.png';
import clearClick from '../images/project/clear-click.png';
import musicMatch from '../images/project/music-match.png';
import websiteHub from '../images/project/website-hub.png';
import cellularAutomataGameImage from '../images/project/cellular-automata-game.png';
import cellularAutomataGameGif from '../images/project/cellular-automata-game.gif';
import plantBuddyImage from '../images/project/plant-buddy.png';


export const projectsData = [
    {
        id: 1,
        name: 'Cellular Automata Game',
        desc: 'A puzzle game where you guide water and other elements through obstacles to fill containers.',
        image: cellularAutomataGameImage,
        gif: cellularAutomataGameGif,
        demo: '#/game/cellular-automata',
        code: 'https://github.com/jerryiscat/Cellular-Automata-Game',
        tags: ['C', 'raylib', 'WebAssembly'],
        features: [
            '4 Levels with increasing difficulty and unique mechanics',
            'Multiple Elements: Walls, Sand, Fire, Water (blue and red)',
            'Plant System: Blue water grows plants, red water destroys them (creates ash)',
            'Physics Simulation: Real-time particle interactions and gravity',
            'Save/Load: Binary serialization to save your progress',
        ],
        controls: [
            'Mouse Left Click: Draw/place elements',
            '1 Key: Wall',
            '2 Key: Sand (Level 2+)',
            '3 Key: Fire (Level 3+)',
            'R Key: Restart current level',
            'F5: Save game',
            'F9: Load game',
            'Click ON/OFF Button: Start/stop water flow'
        ]
    },
    {
        id: 2,
        name: 'MusicMatch',
        desc: 'A music data-driven music social media website, empowered by OpenAI API to generalize music personality and match music buddies!',
        image: musicMatch,
        demo: 'https://github.com/jerryiscat/music-match/blob/main/README.md', 
        code: 'https://github.com/jerryiscat/music-match/blob/main/README.md', 
        tags: ['Node.js', 'JavaScript', 'OpenAI API', 'Vue.js', 'Spotify API']
    },
    {
        id: 3,
        name: 'PlantBuddy',
        desc: 'An iOS app for plant care tracking built with SwiftUI and MVVM, featuring a Django/PostgreSQL backend with local caching and offline support.',
        image: plantBuddyImage,
        demo: 'https://github.com/jerryiscat/plantbuddy',
        code: 'https://github.com/jerryiscat/plantbuddy',
        tags: ['Swift', 'SwiftUI', 'Django', 'PostgreSQL', 'iOS']
    },
    {
        id: 4,
        name: 'ClearClick',
        desc: 'A Chrome Extension for Enhanced Web Navigation, targeted at assisting elderly users and those with reading disabilities.',
        image: clearClick,
        demo: 'https://www.canva.com/design/DAF5EA_V4zM/MKI1MAXLjm9NDXWs2_ojRQ/edit',
        code: 'https://github.com/jerryiscat/clear-click', 
        tags: ['JavaScript', 'Node.js', 'OpenAI API', 'Web Audio API']
    },
    {
        id: 5,
        name: 'WebsiteHub',
        desc: 'A user-centric web platform for sharing and interacting with links.',
        image: websiteHub,
        demo: 'https://github.com/jerryiscat/website-hub/blob/main/README.md', 
        code: 'https://github.com/jerryiscat/website-hub/blob/main/README.md', 
        tags: ['React', 'Express.js', 'MongoDB', 'Azure']
    },
    {
        id: 6,
        name: 'Moody',
        desc: 'A website allowing users to record their mood and listen to corresponding music.',
        image: moodyImage, 
        demo: 'https://moody-340.web.app/',
        code: 'https://github.com/jerryiscat/Moody', 
        tags: ['React', 'CSS', 'Firebase']
    },
    {
        id: 7,
        name: 'HearNature',
        desc: 'An Android app for recording and browsing nature sounds.',
        image: hearNatureImage, 
        demo: 'https://github.com/jerryiscat/HearNature', // Replace with actual URL if available
        code: 'https://github.com/jerryiscat/HearNature',
        tags: ['Java', 'Android', 'Audio']
    },
    // {
    //     id: 3,
    //     name: 'Cfashion',
    //     desc: 'A full-stack E-Commerce platform and Admin Dashboard.',
    //     image: 'path_to_Cfashion_image', // Replace with actual image path
    //     demo: 'url_to_Cfashion_demo', // Replace with actual URL if available
    //     code: 'url_to_Cfashion_repository', // Replace with actual repository URL
    //     tags: ['React', 'Next.js', 'Tailwind CSS', 'Prisma', 'MongoDB', 'NextAuth']
    // },
];
